import React from "react";

import Alert from '@mui/material/Alert';
import PasswordInput from "../../Input";

import { Grid, TextField, Typography, Box, Button } from "@mui/material";
import { CircularProgress } from '@mui/material';
import { clearSession, saveSession, clearToken, saveToken, finishLogin } from "../../../auth";

import { loginWithGoogle, loginWithMicrosoft } from "../../SSO"
import SSOButtons from "../../SSO/Buttons"

import Logo from '../../../assets/images/kwik_white_bg.png'
import api from '../../../api';

import "./styles.css";

class LoginForm extends React.Component {

    constructor(props) {
        super(props);

        const urlParams = new URLSearchParams(window.location.search);
        const username = urlParams.get('username') ;
        const typeAlert = urlParams.get('typeAlert') || '';
        const showAlert = urlParams.get('showAlert') || '';

        const url = new URL(window.location);
        url.search = ""; 
        history.pushState({}, '', url);

        this.state = {
            typeAlert      : typeAlert,
            showAlert      : showAlert,
            loading        : false,
            resetPassword  : false,
            username       : username,
            password       : '',
            responseStatus : 0,
            show2fa        : false,
            sessionId      : "",
            accessCode     : "",
            resendCooldown : 120, // 2 minutes in seconds
            cdInterval     : null,
        }
    }

    startCountdown = () => {
        if (this.state.cdInterval)
            clearInterval(this.state.cdInterval)

        const interval = setInterval(() => {
            this.setState(prevState => {
                if (prevState.resendCooldown <= 1) {
                    clearInterval(interval);
                    return { resendCooldown: 0, cdInterval: null };
                }
                return { resendCooldown: prevState.resendCooldown - 1 }
            })
        }, 1000)

        this.setState({ resendCooldown: 120, cdInterval: interval })
    }

    setShowAlert = (type, value) => {
        this.setState({ typeAlert: type, showAlert: value });
    }

    setLoading = (condition) => {
        this.setState({ loading: condition });
    }

    setResetPassword = (condition) => {
        this.setState({ resetPassword: condition });
    }

    onChangeUsername = (event) => {
        this.setState({ username: event.target.value });
    }

    onChangePassword = (event) => {
        this.setState({ password: event.target.value });
    }

    // finishLogin = async (data) => {
    //     let agentId = null;
    //     try {
    //         agentId = data.user.profile.agent.id;
    //     } catch (e) {
    //         if (e instanceof TypeError) {
    //             this.setShowAlert("error", "Não há operador relacionado à este usuário.");
    //             this.setState({ loading: false });
    //             return;
    //         }
    //         throw e;
    //     }
    //     if (! agentId) return;
        
    //     // Only save token if user has an agent related
    //     saveToken(data.access);

    //     // Login related agent
    //     await api.post(`/api/IV/agents/${agentId}/login/`).then((res) => {
    //         if (res.status == 200 && res.data.agentstatus != 'LOGOFF') {
    //             // Replacing agent data with new status
    //             data.user.profile.agent = res.data;
    //             saveSession(data.user);
    //             window.location.href = '/chat';
    //             return;
    //         }
    //         throw res;
    //     }).catch((err) => {
    //         console.error('Couldnt login agent [err:%o]', err);
    //         clearToken();
    //         clearSession();
    //         if ('data' in err && err.data[0] === 'Sua desgutação Kwik chegou ao fim.')
    //             this.setShowAlert("error", err.data);
    //         else
    //             this.setShowAlert("error", "Algo deu errado, tente novamente.");
    //         this.setState({ loading: false });
    //     });
    // }

    login = () => {
        if (!this.state.username) {
            this.setShowAlert("error", "E-mail não informado.");
            return;
        } else if (!this.state.password) {
            this.setShowAlert("error", "Senha não informada.");
            return;
        }

        this.setState({ loading: true });

        fetch('/api/auth/token/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                username: (this.state.username).toLowerCase(),
                password: this.state.password
            })
        }).then((res) => {
            if (res.status == 200)
                return res.json(); 
            throw res;
        }).then(async (data) => {
            await finishLogin(data, this.setShowAlert, (value) => this.setState({ loading: value }))
        }).catch( async (err) => {
            this.setState({ loading: false })
            const data = await err.json()
            if (err.status == 400) {
                const detail = Array.isArray(data.detail) ? data.detail : []
                const session = Array.isArray(data.session_id) ? data.session_id : []
                const errorMessage = detail.pop()
                if (errorMessage === "OTP required.") {
                    this.setState({ 
                        show2fa: true,
                        sessionId: session.pop()
                    })
                    this.startCountdown()
                }
                if (errorMessage === "Please wait a few minutes before requesting again.") {
                    this.setShowAlert(
                        "warning",
                        "Aguarde alguns instantes para poder receber o código de acesso novamente."
                    )
                }
                if (errorMessage === "User telephone is required.") {
                    this.setShowAlert(
                        "warning",
                        "Usuário sem telefone cadastrado."
                    )
                }
                if (errorMessage === "Password authentication not allowed.") {
                    this.setShowAlert(
                        "warning",
                        "Sua conta não permite acesso por senha."
                    )
                }
            } else {
                this.setShowAlert("error", data?.message || "Credenciais incorretas, tente novamente.")
                console.log(err)
            }
        });
    }

    verify2fa = () => {
        this.setState({ loading: true })
        fetch("/api/auth/otp/verify/", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                session_id: this.state.sessionId,
                code: this.state.accessCode
            })
        }).then((res) => {
            if (res.status === 200)
                return res.json()
            throw res
        }).then(async (data) => {
            await this.finishLogin(data)
        }).catch(async(err) => {
            this.setState({ loading: false })
            console.error(err)
            const data = await err.json()
            if (err.status == 400)
                this.setShowAlert("error", "Código de acesso inválido.")
            else
                this.setShowAlert("error", "Algo deu errado, tente novamente.")
        })
    }

    fetchResetPassword = () => {
        this.setState({ loading: true });

        fetch('/api/api/users/password/reset/', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                username: (this.state.username).toLowerCase()
            })
        }).then((res) => {
            if (res.status == 200) {
                this.setState({ loading: false });
                this.setResetPassword(false);
                this.setShowAlert("success", 'Um link para redefinição de senha foi enviado ao seu e-mail.');
            }
            throw res;
        }).catch((err) => {
            if (err.status !== 200) {
                console.error(err);
                this.setState({ loading: false });

                if (err.status === 404) {
                    this.setShowAlert("error", "Endereço de e-mail não encontrado.");

                } else {
                    this.setShowAlert("error", "Algo deu errado, tente novamente.");
                }
            }
        });
    }

    handleKeyPress = (event) => {
        if(event && event.key === 'Enter'){
            this.login();
        }
    }

    handleKeyPressReset = (event) => {
        if(event && event.key === 'Enter'){
            this.fetchResetPassword();
        }
    }

    submitLogin = () => {
        this.login();
    }

    submitResetPassword = () => {
        this.fetchResetPassword();
    }

    getCurrentYear() {
        return new Date().getFullYear();
    }

    
    gotCTA = () => {
        window.open('https://landing.kwik.app.br/kwik/')
    }

    render() {
        return (
            <Box ml={15} mr={15} sx={{flexDirection: 'column'}} className="form-login">
                {this.state.resetPassword === false &&
                    <Grid container spacing={2}>
                        {window.innerWidth <= 960 &&
                            <Grid item lg={12} md={12} sm={12} xs={12} className="kwik-logo-container">
                                <img src={Logo} alt="logo" onClick={this.gotCTA} className="kwik-logo"/>
                            </Grid> 
                        }
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography className="title" variant="h4">Acesse sua conta</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            {this.state.showAlert !== "" &&
                                <Alert 
                                    className="login-validation"
                                    severity={this.state.typeAlert} 
                                    onClose={() => this.setShowAlert("", "")}
                                >
                                    {this.state.showAlert}
                                </Alert>
                            }
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                                label="E-mail"
                                variant="outlined"
                                name="username"
                                defaultValue={this.state.username}
                                onChange={this.onChangeUsername}
                                fullWidth
                                required
                                size="small"
                                onKeyPress={this.handleKeyPress}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <PasswordInput
                                label="Senha"
                                name="password"
                                defaultValue={this.state.password}
                                onChange={this.onChangePassword}
                                onEnterPress={true}
                                onKeyPress={this.handleKeyPress}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            {this.state.show2fa
                                ? (
                                    <Box display="flex" flexDirection="column" gap={2}>
                                        <TextField
                                            size="small"
                                            label="Código de acesso"
                                            value={this.state.accessCode}
                                            onChange={(event) => {
                                                const value = event.target.value
                                                if (/^\d{0,6}$/.test(value))
                                                    this.setState({ accessCode: value })
                                            }}
                                            inputProps={{
                                                inputMode: "numeric",
                                                pattern: "[0-9]*",
                                                maxLength: 6
                                            }}
                                        />
                                        <Button 
                                            variant="contained" 
                                            color="primary"
                                            disabled={this.state.loading || this.state.accessCode.length !== 6}
                                            onClick={() => this.verify2fa()}
                                        >
                                            {this.state.loading &&
                                                <CircularProgress style={{
                                                    height: "20px",
                                                    width: "20px",
                                                    marginRight: "10px"
                                                }}/>
                                            }
                                            Confirmar Código
                                        </Button>
                                        {this.state.resendCooldown > 0
                                            ? (
                                                <Box textAlign="center">
                                                    <small>Você poderá solicitar um novo código em {Math.floor(this.state.resendCooldown / 60)}:{String(this.state.resendCooldown % 60).padStart(2, '0')}</small>
                                                </Box>
                                            ) 
                                            : (
                                                <Box 
                                                    sx={{
                                                        textAlign: "center",
                                                        textDecoration: "underline",
                                                        cursor: "pointer"
                                                    }} 
                                                    onClick={() => this.submitLogin()}
                                                >
                                                    Solicitar novo código
                                                </Box>
                                            )
                                        }
                                    </Box>
                                )
                                : (
                                    <>
                                        <Button disabled={this.state.loading || this.state.show2fa}
                                            variant="contained"
                                            color="primary"
                                            type="submit"
                                            onClick={() => this.submitLogin()}
                                            fontSize="small"
                                            fullWidth
                                        >
                                            {this.state.loading &&
                                                <CircularProgress style={{
                                                    height: "20px",
                                                    width: "20px",
                                                    marginRight: "10px"
                                                }}/>
                                            }
                                            Entrar
                                        </Button>

                                        <Box className="sso-login-divider">
                                            <Box sx={{ flex: 1, borderBottom: "1px solid #ddd" }} />
                                            <Typography sx={{ px: 2 }}>
                                                ou
                                            </Typography>
                                            <Box sx={{ flex: 1, borderBottom: "1px solid #ddd" }} />
                                        </Box>

                                        <SSOButtons
                                            googleSso={() => 
                                                loginWithGoogle({
                                                    finishLogin,
                                                    setShowAlert: (message) => this.setShowAlert("error", message),
                                                    setLoading: (value) => this.setState({ loading: value })
                                                })
                                            }
                                            microsoftSso={() =>
                                                loginWithMicrosoft({
                                                    finishLogin,
                                                    setShowAlert: (message) => this.setShowAlert("error", message),
                                                    setLoading: (value) => this.setState({ loading: value })
                                                })
                                            }
                                            disabled={this.state.loading}
                                        />

                                        <Box className="reset-password" onClick={() => this.setResetPassword(true)}>
                                            Esqueci minha senha
                                        </Box>
                                    </>
                                )
                            }
                        </Grid>
                    </Grid>
                }
                {this.state.resetPassword === true &&
                    <Grid container spacing={2}>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Typography className="title" variant="h4">Redefinir sua senha</Typography>
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            {this.state.showAlert !== "" &&
                                <Alert 
                                    className="login-validation"
                                    severity={this.state.typeAlert} 
                                    onClose={() => this.setShowAlert("", "")}
                                >
                                    {this.state.showAlert}
                                </Alert>
                            }
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <TextField
                                id="username"
                                label="E-mail"
                                variant="outlined"
                                name="username"
                                value={this.state.username}
                                onChange={this.onChangeUsername}
                                error={this.state.username ? "" : "Este campo é obrigatório"}
                                helperText={this.state.username ? "" : "Este campo é obrigatório"}
                                fullWidth
                                required
                                size="small"
                                onKeyPress={this.handleKeyPressReset}
                            />
                        </Grid>
                        <Grid item lg={12} md={12} sm={12} xs={12}>
                            <Button disabled={this.state.loading}
                                    variant="contained"
                                    color="primary"
                                    type="submit"
                                    onClick={() => this.fetchResetPassword()}
                                    fontSize="small"
                                    fullWidth
                            >
                                {this.state.loading &&
                                    <CircularProgress style={{
                                        height: "20px",
                                        width: "20px",
                                        marginRight: "10px"
                                    }}/>
                                }
                                Enviar
                            </Button>
                            <Box 
                                className="reset-password" 
                                onClick={() => this.setResetPassword(false)}
                            >
                                Voltar
                            </Box>
                        </Grid>
                    </Grid >
                }
                <Grid container spacing={2} sx={{justifyContent: 'center', alignItems: 'flex-end', position: 'absolute', bottom: '1vh', padding: '0 3rem'}} flex={1}>
                    <Grid item>
                        <Typography variant="body2" align="center">
                            Copyright (c) {this.getCurrentYear()} - <a href="http://www.instant.com.br/">Instant Solutions Tecnologia e Informática Ltda.</a>
                            <br /><a href="https://www.instant.com.br/politica-de-privacidade/">Política de Privacidade</a>
                        </Typography>
                    </Grid>
                </Grid>
            </Box >
        );
    }
}

export default LoginForm;
